var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex pt-0 pr-0 pl-0 pb-5 justify-content-center justify-content-md-end"},[_c('v-select',{staticClass:"yearly-select",attrs:{"background-color":"white","outlined":"","dense":"","hide-details":"","items":_vm.items},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }